import { render, staticRenderFns } from "./UkrposhtaEditing.vue?vue&type=template&id=cc135cb0&scoped=true"
import script from "./UkrposhtaEditing.vue?vue&type=script&lang=js"
export * from "./UkrposhtaEditing.vue?vue&type=script&lang=js"
import style0 from "./UkrposhtaEditing.vue?vue&type=style&index=0&id=cc135cb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc135cb0",
  null
  
)

export default component.exports